import axios from "axios";

export const createSession = async (csvFile, metadata) => {
  const token = localStorage.getItem("token");
  const apiUrlUploadSession = `${process.env.REACT_APP_API}sessions`;

  if (!token) {
    throw new Error("No se encontró un token");
  }

  const formData = new FormData();
  formData.append("csv_file", csvFile);
  formData.append("metadata", JSON.stringify(metadata));

  try {
    const response = await axios.post(apiUrlUploadSession, formData, {
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "multipart/form-data",
      },
    });

    console.log(response.data);
    return response.data;
  } catch (error) {
    console.error("Error en la solicitud:", error);
    throw error;
  }
};

export const deleteSessions = async (sessionIds) => {
  const token = localStorage.getItem("token");
  const apiUrlDeleteSessions = `${process.env.REACT_APP_API}sessions`;

  if (!token) {
    throw new Error("No se encontró un token");
  }

  const formData = new FormData();
  formData.append("session_ids", sessionIds);

  try {
    const response = await axios.delete(apiUrlDeleteSessions, {
      data: sessionIds,
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    });
    return response.data;
  } catch (error) {
    console.error("Error en la solicitud:", error);
    throw error;
  }
};
